export const FONT_FAMILY_REGEX = /font-family:\s*['"]?([^'";]*)['"]?/gi;
export const FONT_FACE_REGEX = /@font-face\s*{([^}]*)}/g;
export const FONT_FACE_PROPERTY_REGEX = /([a-z-]+)\s*:\s*([^;]+);/g;
export const FONT_FACE_SOURCE_REGEX = /url\([^)]+\)\s*format\(["']([^"']+)["']\)/g;
export const CAMEL_CASE_REGEX = /-([a-z])/g;
export const FONT_FACE_PROPERTY_PREFIX_REGEX = /^font-/;
export const DEFAULT_OPTIONS = {
  skipDeleted: true,
  skipLoaded: true,
  variants: [
    // { weight: 400, style: 'normal' },
  ]
};
export const FONT_FACE_TYPES = {
  woff2: 'woff2',
  woff: 'woff',
  otf: 'opentype',
  ttf: 'truetype',
  otc: 'collection',
  ttc: 'collection',
  eot: 'embedded-opentype',
  svg: 'svg',
  svgz: 'svg'
};
export const FONT_FALLBACK = 'Nunito';
